<template>
  <div class="contact-button">
    <nuxt-link
      to="/contact-us"
      class="btn btn-lg text-white shadow contact-link"
      data-bs-toggle="tooltip"
      data-bs-placement="top"
    >
      <h4><i class="fa-solid fa-headset"></i></h4>
    </nuxt-link>
  </div>
</template>
<style scoped>
.contact-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.contact-link {
  background-color: #fb8b34;
  width: 60px; 
  height: 60px; 
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
